<template>
  <router-view v-if="$can('access-settings')" />
</template>

<script>
export default {
  name: 'Settings'
}
</script>
